import { Injectable, inject } from '@angular/core';
import { CasesState } from '../../states/cases.state';

/**
 * Clear Messages Use Case
 * Clears messages from state (used when navigating between cases)
 */
@Injectable({ providedIn: 'root' })
export class ClearMessagesUseCase {
  private readonly _state = inject(CasesState);

  public execute(): void {
    this._state.setMessages([]);
  }
}
